export default __webpack_public_path__ + "static/media/close-icon.aeb1f823.svg";